function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.25 4.5C0.25 3.25736 1.25736 2.25 2.5 2.25H19.5C20.7426 2.25 21.75 3.25736 21.75 4.5V17.5C21.75 18.7426 20.7426 19.75 19.5 19.75H2.5C1.25736 19.75 0.25 18.7426 0.25 17.5V4.5ZM2.5 3.75C2.08579 3.75 1.75 4.08579 1.75 4.5V17.5C1.75 17.9142 2.08579 18.25 2.5 18.25H19.5C19.9142 18.25 20.25 17.9142 20.25 17.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75H2.5Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.75 8.5C0.75 8.08579 1.08579 7.75 1.5 7.75H20.5C20.9142 7.75 21.25 8.08579 21.25 8.5C21.25 8.91421 20.9142 9.25 20.5 9.25H1.5C1.08579 9.25 0.75 8.91421 0.75 8.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 0.25C14.9142 0.25 15.25 0.585786 15.25 1V5C15.25 5.41421 14.9142 5.75 14.5 5.75C14.0858 5.75 13.75 5.41421 13.75 5V1C13.75 0.585786 14.0858 0.25 14.5 0.25Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 0.25C7.91421 0.25 8.25 0.585786 8.25 1V5C8.25 5.41421 7.91421 5.75 7.5 5.75C7.08579 5.75 6.75 5.41421 6.75 5V1C6.75 0.585786 7.08579 0.25 7.5 0.25Z",
  fill: "white"
});

function SvgMenuCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCalendar);
export default __webpack_public_path__ + "static/media/MenuCalendar.1b38f290.svg";
export { ForwardRef as ReactComponent };